/* BF-retailer-locator.js */
(function () {
  const byId = (id) => document.getElementById(id);

  function normalize(s) {
    return (s || "").toString().toLowerCase().trim();
  }

  function formatAddress(r) {
    const parts = [r.address, r.zip, r.city, r.country].filter(Boolean);
    return parts.join(", ");
  }

  async function fetchJSON(url) {
    const res = await fetch(url, { cache: "no-store" });
    if (!res.ok) throw new Error("Failed to load retailers data");
    return res.json();
  }

  function buildOption(select, value, label) {
    const opt = document.createElement("option");
    opt.value = value;
    opt.textContent = label;
    select.appendChild(opt);
  }

  function escapeHtml(s) {
    return (s ?? "").toString().replace(/[&<>"']/g, (c) => ({
      "&": "&amp;",
      "<": "&lt;",
      ">": "&gt;",
      '"': "&quot;",
      "'": "&#39;",
    }[c]));
  }

  function normalizePhoneForTel(phone) {
    return (phone || "").toString().replace(/[^\d+]/g, "");
  }

  function buildInfoHtml(r) {
    const title = escapeHtml(r.title || "");
    const address = escapeHtml(formatAddress(r));

    const phone = (r.phone || "").toString().trim();
    const website = (r.website || "").toString().trim();

    const phoneHtml = phone
      ? `<div class="bf-iw__line">
           <a class="bf-iw__link" href="tel:${escapeHtml(normalizePhoneForTel(phone))}">${escapeHtml(phone)}</a>
         </div>`
      : "";

    const websiteHtml = website
      ? `<div class="bf-iw__line">
           <a class="bf-iw__link" href="${escapeHtml(website)}" target="_blank" rel="noopener">Website</a>
         </div>`
      : "";

    return `
      <div class="bf-iw">
        <div class="bf-iw__title">${title.toUpperCase()}</div>
        <div class="bf-iw__line">${address}</div>
        ${phoneHtml}
        ${websiteHtml}
      </div>
    `;
  }

  async function getIpCountryName() {
    const res = await fetch("https://ipapi.co/json/", { cache: "no-store" });
    if (!res.ok) return null;

    const j = await res.json();

    if (j && j.country_name) return j.country_name;

    if (j && j.country_code && typeof Intl !== "undefined" && Intl.DisplayNames) {
      try {
        const dn = new Intl.DisplayNames(["en"], { type: "region" });
        const n = dn.of(String(j.country_code).toUpperCase());
        return n || null;
      } catch (e) {}
    }

    return null;
  }

  window.RetailerLocator = {
    init: async function (cfg) {
      const mapEl = byId(cfg.mapId);
      const listEl = byId(cfg.listId);
      const searchEl = byId(cfg.searchId);
      const countryEl = byId(cfg.countryId);
      const cityEl = byId(cfg.cityId);

      const data = await fetchJSON(cfg.dataUrl);

      data.forEach((r) => {
        if (typeof r.lat === "string") r.lat = parseFloat(r.lat);
        if (typeof r.lng === "string") r.lng = parseFloat(r.lng);
        if (!Number.isFinite(r.lat)) delete r.lat;
        if (!Number.isFinite(r.lng)) delete r.lng;
      });

const map = new google.maps.Map(mapEl, {
  center: cfg.center,
  zoom: cfg.zoom,
  mapTypeControl: false,
  streetViewControl: false,
  fullscreenControl: true,
  mapId: '7f643514f5d57bfdc551b9a5'
});

      const info = new google.maps.InfoWindow({
        pixelOffset: new google.maps.Size(0, -12),
        disableAutoPan: true,
      });

      const geocoder = new google.maps.Geocoder();

      const ZOOM_SINGLE = 14;
      const MAX_FIT_ZOOM = 14;
      const MIN_FIT_ZOOM = 3;

      const markerByKey = new Map();
      const cardByKey = new Map();

      function retailerKey(r) {
        return [
          (r.title || "").trim(),
          (r.address || "").trim(),
          (r.city || "").trim(),
          (r.country || "").trim(),
        ].join("|").toLowerCase();
      }

      function isElementInView(container, el) {
        const cRect = container.getBoundingClientRect();
        const eRect = el.getBoundingClientRect();
        return eRect.top >= cRect.top && eRect.bottom <= cRect.bottom;
      }

      function highlightCard(key, on) {
        const el = cardByKey.get(key);
        if (!el) return;

        el.classList.toggle("is-active", !!on);

        if (on) {
          const container = el.closest(".retailer-locator__list");
          if (container && !isElementInView(container, el)) {
            el.scrollIntoView({ behavior: "smooth", block: "nearest" });
          }
        }
      }

      function setMarkerIcon(marker, sizePx) {
        if (!cfg.markerIconUrl) return;

        const s = typeof sizePx === "number" ? sizePx : 56;
        const anchorX = Math.round(s / 2);
        const anchorY = s;

        marker.setIcon({
          url: cfg.markerIconUrl,
          scaledSize: new google.maps.Size(s, s),
          anchor: new google.maps.Point(anchorX, anchorY),
        });
      }

      function highlightMarker(key, on) {
        const marker = markerByKey.get(key);
        if (!marker) return;

        setMarkerIcon(marker, on ? 72 : 56);
        marker.setZIndex(on ? 999 : undefined);
      }

      const countries = [...new Set(data.map((d) => d.country).filter(Boolean))].sort();
      countries.forEach((c) => buildOption(countryEl, c, c));

      function updateCities() {
        cityEl.innerHTML = "";
        buildOption(cityEl, "", "All cities");

        const selectedCountry = countryEl.value;
        const cities = [
          ...new Set(
            data
              .filter((d) => !selectedCountry || d.country === selectedCountry)
              .map((d) => d.city)
              .filter(Boolean)
          ),
        ].sort();

        cities.forEach((c) => buildOption(cityEl, c, c));
      }

      updateCities();

      async function ensureLatLng(r) {
        if (Number.isFinite(r.lat) && Number.isFinite(r.lng)) return r;

        const addr = formatAddress(r);
        if (!addr) return r;

        const result = await new Promise((resolve) => {
          geocoder.geocode({ address: addr }, (results, status) => {
            if (status === "OK" && results && results[0]) resolve(results[0].geometry.location);
            else resolve(null);
          });
        });

        if (result) {
          r.lat = result.lat();
          r.lng = result.lng();
        }

        return r;
      }

      let markers = [];

      function clearMarkers() {
        markers.forEach((m) => m.setMap(null));
        markers = [];
        markerByKey.clear();
      }

      async function renderMarkers(rows) {
        clearMarkers();

        for (const r of rows) {
          await ensureLatLng(r);
          if (!Number.isFinite(r.lat) || !Number.isFinite(r.lng)) continue;

          const key = retailerKey(r);

          const marker = new google.maps.Marker({
            map,
            position: { lat: r.lat, lng: r.lng },
            title: r.title || "",
          });

          setMarkerIcon(marker, 56);
          markerByKey.set(key, marker);

          marker.addListener("mouseover", () => {
            highlightMarker(key, true);
            highlightCard(key, true);
          });

          marker.addListener("mouseout", () => {
            highlightMarker(key, false);
            highlightCard(key, false);
          });

          marker.addListener("click", () => {
            openRetailerInfo(r, key);
          });

          markers.push(marker);
        }
      }

      function renderList(rows) {
        listEl.innerHTML = "";
        cardByKey.clear();

        if (!rows.length) {
          listEl.innerHTML = "<p>No retailers found.</p>";
          return;
        }

        const groups = new Map();
        rows.forEach((r) => {
          const c = (r.country || "Other").trim();
          if (!groups.has(c)) groups.set(c, []);
          groups.get(c).push(r);
        });

        const countryNames = Array.from(groups.keys()).sort((a, b) => a.localeCompare(b));

        countryNames.forEach((countryName) => {
          const header = document.createElement("div");
          header.className = "retailer-country";
          header.textContent = (countryName || "").toUpperCase();
          listEl.appendChild(header);

          groups.get(countryName).forEach((r) => {
            const key = retailerKey(r);

            const card = document.createElement("div");
            card.className = "retailer-card";
            card.innerHTML = `
              <div class="retailer-card__title">${escapeHtml(r.title || "").toUpperCase()}</div>
              <div class="retailer-card__line">${escapeHtml(formatAddress(r))}</div>
              ${r.phone ? `<div class="retailer-card__line">${escapeHtml(r.phone)}</div>` : ""}
              ${r.website ? `<div class="retailer-card__line"><a href="${escapeHtml(r.website)}" target="_blank" rel="noopener">Website</a></div>` : ""}
            `;

            cardByKey.set(key, card);

            card.addEventListener("mouseenter", () => {
              highlightCard(key, true);
              highlightMarker(key, true);
            });

            card.addEventListener("mouseleave", () => {
              highlightCard(key, false);
              highlightMarker(key, false);
            });

            card.addEventListener("click", () => {
              if (!Number.isFinite(r.lat) || !Number.isFinite(r.lng)) return;
              openRetailerInfo(r, key);
            });

            listEl.appendChild(card);
          });
        });
      }

      function focusMapOnRows(rows) {
        const withCoords = rows.filter((r) => Number.isFinite(r.lat) && Number.isFinite(r.lng));

        if (!withCoords.length) {
          info.close();
          map.setCenter(cfg.center);
          map.setZoom(cfg.zoom);
          return;
        }

        if (withCoords.length === 1) {
          map.setCenter({ lat: withCoords[0].lat, lng: withCoords[0].lng });
          map.setZoom(ZOOM_SINGLE);
          return;
        }

const bounds = new google.maps.LatLngBounds();
withCoords.forEach((r) => bounds.extend({ lat: r.lat, lng: r.lng }));

const boundsPadding = window.innerWidth < 750
  ? { top: 90, right: 30, bottom: 30, left: 30 }
  : { top: 60, right: 40, bottom: 40, left: 40 };

map.fitBounds(bounds, boundsPadding);

google.maps.event.addListenerOnce(map, "idle", () => {
  const z = map.getZoom();
  if (typeof z === "number") {
    if (z > MAX_FIT_ZOOM) map.setZoom(MAX_FIT_ZOOM);
    if (z < MIN_FIT_ZOOM) map.setZoom(MIN_FIT_ZOOM);
  }
});
      }

function openRetailerInfo(r, key) {
  const marker = markerByKey.get(key);

  const doOpen = () => {
    info.setContent(buildInfoHtml(r));

    if (marker) {
      info.open({
        map,
        anchor: marker,
        shouldFocus: false,
      });
    } else {
      info.setPosition({ lat: r.lat, lng: r.lng });
      info.open({
        map,
        shouldFocus: false,
      });
    }

    map.panBy(0, window.innerWidth < 750 ? -120 : -120);
  };

  if (window.innerWidth < 750) {
    focusMapOnRows([r]);
    google.maps.event.addListenerOnce(map, "idle", () => {
      setTimeout(doOpen, 50);
    });
  } else {
    focusMapOnRows([r]);
    doOpen();
  }
}

      async function applyFilters(opts = { focus: false }) {
        const q = normalize(searchEl.value);
        const ctry = countryEl.value;
        const cty = cityEl.value;

        const rows = data.filter((r) => {
          if (ctry && r.country !== ctry) return false;
          if (cty && r.city !== cty) return false;

          if (!q) return true;

          const hay = normalize([r.title, r.address, r.city, r.country].join(" "));
          return hay.includes(q);
        });

        renderList(rows);
        await renderMarkers(rows);

        if (!ctry && !cty && !q) {
          info.close();
          map.setCenter(cfg.center);
          map.setZoom(cfg.zoom);
          return;
        }

        if (opts.focus) {
          focusMapOnRows(rows);
        }
      }

      let userTouchedFilters = false;

      async function autoSelectCountryLater() {
        if (!cfg.ipCountry) return;

        let ipCountryName = null;
        try {
          ipCountryName = await getIpCountryName();
        } catch (e) {
          ipCountryName = null;
        }

        if (userTouchedFilters || !ipCountryName) return;

        const desired = ipCountryName.toLowerCase();
        const match =
          countries.find((c) => c === ipCountryName) ||
          countries.find((c) => (c || "").toLowerCase() === desired);

        if (!match) return;

        countryEl.value = match;
        updateCities();

        await applyFilters({ focus: true });
      }

      searchEl.addEventListener("input", () => {
        userTouchedFilters = true;
        applyFilters({ focus: false });
      });

      countryEl.addEventListener("change", () => {
        userTouchedFilters = true;
        updateCities();
        applyFilters({ focus: true });
      });

      cityEl.addEventListener("change", () => {
        userTouchedFilters = true;
        applyFilters({ focus: true });
      });

      applyFilters({ focus: false });
      autoSelectCountryLater();
    },
  };
})();